module.exports = __webpack_public_path__ + "img/download_icon.a1475045.svg";